import { connect } from "react-redux";
import PaymentList from "./paymentList";
import { bindActionCreators } from "redux";
import { getVendorPaymentRequestList,getListFilterData } from "services/redux/sales/vendorPortal/action";

import {
  fetchZones
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  dataList: state.vendorPortalReducer.payment_request_list,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.vendorPortalReducer.list_filter,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      fetchZones,
      getVendorPaymentRequestList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentList);
